import { Box, Container, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import theme from 'src/style-system/theme';
import CuminButton from '@components/Button';
import { AppRoutes } from '@utils/appRoutes';
import { ICountryList } from '@utils/types';

interface IFoodIsHappiness {
  selectedCountryDetail: ICountryList;
}

const FoodIsHappiness = ({ selectedCountryDetail }: IFoodIsHappiness) => {
  const router = useRouter();

  const sendGiftCard = () => {
    router.push(
      `/${selectedCountryDetail?.country_code}${AppRoutes.GIFT_CARD_STEP_ONE}`
    );
  };

  const sendGiftBox = () => {
    router.push(`${AppRoutes.NEW_US_GIFT_BOX}&isBackToGift=${AppRoutes.GIFT}`);
  };

  return (
    <Box bgcolor="cinnamon.main" padding={{ xs: '40px 25px', md: '50px' }}>
      <Container maxWidth="xl" disableGutters>
        <Typography variant="h1" align="center" color="whitePepper.main">
          Food is Happiness
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            rowGap: '20px',
            [theme.breakpoints.up('md')]: {
              flexDirection: 'row',
              columnGap: '45px',
            },
          }}
          mt={{ xs: '30px', md: '40px' }}
        >
          <CuminButton
            color="turmeric"
            variant="contained"
            textColor="garamMasala.main"
            width="215px"
            height="48"
            borderRadius="24"
            onClick={sendGiftBox}
          >
            Send a Gift Box
          </CuminButton>
          <CuminButton
            color="turmeric"
            variant="contained"
            textColor="garamMasala.main"
            width="215px"
            height="48"
            borderRadius="24"
            onClick={sendGiftCard}
          >
            Send a Gift Card
          </CuminButton>
        </Box>
      </Container>
    </Box>
  );
};

export default FoodIsHappiness;
